/**
 * CollectiveCommunityLink — small, calm CTA pill that opens the Collective
 * Alignment flow scoped to a specific community via `?community=<id>`.
 *
 * Use on any community landing surface (Networker, Aurum, Golf, sports
 * teams, leadership cohorts) so members tap into THEIR shared collective
 * rather than the global humanity-wide one.
 *
 * <CollectiveCommunityLink community="networker_edge" label="The Networker collective" />
 */
import { useNavigate } from "react-router-dom";
import { Users, ChevronRight } from "lucide-react";

export const CollectiveCommunityLink = ({ community, label, sublabel, className = "", "data-testid": testId }) => {
  const navigate = useNavigate();
  if (!community) return null;
  return (
    <button
      onClick={() => navigate(`/collective?community=${encodeURIComponent(community)}`)}
      className={`w-full rounded-2xl px-5 py-4 flex items-center gap-4 text-left transition-all hover:scale-[1.005] ${className}`}
      style={{
        background:
          "linear-gradient(145deg, rgba(31,58,92,0.95) 0%, rgba(13,31,58,1) 60%, rgba(6,14,31,1) 100%)",
        border: "1px solid rgba(241,210,156,0.20)",
        boxShadow: "0 0 30px rgba(241,210,156,0.08)",
      }}
      data-testid={testId || `collective-link-${community}`}
    >
      <div
        className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 border"
        style={{
          background: "radial-gradient(circle, rgba(241,210,156,0.22) 0%, transparent 70%)",
          borderColor: "rgba(241,210,156,0.25)",
        }}
      >
        <Users size={18} strokeWidth={1.4} style={{ color: "rgba(241,210,156,0.85)" }} />
      </div>
      <div className="flex-1 min-w-0">
        <p
          className="text-[10px] uppercase tracking-[0.32em] font-medium mb-0.5"
          style={{ color: "rgba(241,210,156,0.70)" }}
        >
          Collective Alignment
        </p>
        <h4
          className="text-sm font-light italic"
          style={{ fontFamily: "'Playfair Display', serif", color: "rgba(255,255,255,0.92)" }}
        >
          {label || "Drop into the shared field"}
        </h4>
        {sublabel && (
          <p className="text-xs mt-0.5 font-light" style={{ color: "rgba(255,255,255,0.50)" }}>
            {sublabel}
          </p>
        )}
      </div>
      <ChevronRight size={18} style={{ color: "rgba(241,210,156,0.45)" }} />
    </button>
  );
};

export default CollectiveCommunityLink;
